module.exports = Phaser;


//////////////////
// WEBPACK FOOTER
// external "Phaser"
// module id = 0
// module chunks = 0